import { createContext, useContext, useState, useCallback } from "react";

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
	const [error, setError] = useState(null);

	const showError = useCallback((message) => {
		setError(message);
	}, []);

	const clearError = useCallback(() => {
		setError(null);
	}, []);

	return (
		<ErrorContext.Provider value={{ error, showError, clearError }}>
			{children}
		</ErrorContext.Provider>
	);
};

export const useError = () => useContext(ErrorContext);
